import type { Template, TunaPlugin } from '@tunasong/plugin-lib'
import type { FC } from 'react'
import { useState } from 'react'
import TemplatePlugins from './templates-plugins.js'
import TemplateSearch from './templates-search.js'

interface TemplateGridProps {
  plugins: TunaPlugin[]
  onSelect: (template: Template) => void
}

export const TemplateGrid: FC<TemplateGridProps> = props => {
  const { onSelect, plugins } = props
  const [selected, setSelected] = useState<Template>()

  const handleSelect = (template: Template) => {
    setSelected(template)
    onSelect(template)
  }

  return (
    <>
      <TemplatePlugins plugins={plugins} selected={selected} onSelect={handleSelect} />

      <TemplateSearch plugins={plugins} selected={selected} onSelect={handleSelect} />
    </>
  )
}

export default TemplateGrid
